import api from '../utils/api';

// Get all receipts with pagination and filters
export const getReceipts = async (params = {}) => {
  return await api.get('api/receipts', { params });
};

// Get receipt by ID
export const getReceiptById = async (id) => {
  return await api.get(`api/receipts/${id}`);
};

// Create new receipt
export const createReceipt = async (receiptData) => {
  return await api.post('api/receipts', receiptData);
};

// Update receipt
export const updateReceipt = async (id, receiptData) => {
  return await api.put(`api/receipts/${id}`, receiptData);
};

// Delete receipt
export const deleteReceipt = async (id) => {
  return await api.delete(`api/receipts/${id}`);
};

// Record payment for receipt
export const payReceipt = async (id, paymentData) => {
  return await api.put(`api/receipts/${id}/pay`, paymentData);
};

export const previewReceiptPosting = async (id, params = {}) => {
  const query = { ...params };
  if (query.account_overrides) query.account_overrides = JSON.stringify(query.account_overrides);
  return await api.get(`api/accounting/receipts/${id}/preview`, { params: query });
};

export const postReceiptToAccounting = async (id, options = {}) => {
  return await api.post(`api/accounting/receipts/${id}/post`, options);
};

// Get sales dashboard stats
export const getSalesStats = async (period = 'month') => {
  return await api.get('api/receipts/dashboard/stats', {
    params: { period }
  });
};

// Helper function to get status label in Thai
export const getReceiptStatusLabel = (status) => {
  const statusMap = {
    'invoice': 'ใบแจ้งหนี้',
    'paid': 'ชำระแล้ว',
    'partial': 'ชำระบางส่วน',
    'overdue': 'เกินกำหนด',
    'cancelled': 'ยกเลิก'
  };
  return statusMap[status] || status;
};

// Helper function to get status color
export const getReceiptStatusColor = (status) => {
  const colorMap = {
    'invoice': 'processing',
    'paid': 'success',
    'partial': 'warning',
    'overdue': 'error',
    'cancelled': 'default'
  };
  return colorMap[status] || 'default';
};
